var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "registry-action-panel" },
    [
      _vm.isLinks
        ? _c("RegistryActionLinks", {
            ref: "links",
            attrs: {
              action: _vm.action,
              "can-update": _vm.canUpdate,
              metadata: _vm.metadata,
              "before-navigate": _vm.beforeNavigate,
            },
            on: {
              state: _vm.onChildState,
              saved: _vm.linkedSaved,
              cancel: function ($event) {
                return _vm.$emit("cancel")
              },
              "open-entity": function ($event) {
                return _vm.$emit("open-entity", $event)
              },
            },
          })
        : [
            _c("h5", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            !_vm.canUpdate
              ? _c(
                  "p",
                  { staticClass: "text-muted", attrs: { role: "status" } },
                  [_vm._v("You have read-only access.")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.error
              ? _c(
                  "b-alert",
                  {
                    ref: "errorAlert",
                    attrs: {
                      tabindex: "-1",
                      show: "",
                      variant: "danger",
                      role: "alert",
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.readable(_vm.error.message)) +
                        "\n      "
                    ),
                    Object.keys(_vm.error.errors || {}).length
                      ? _c(
                          "ul",
                          { staticClass: "mb-0" },
                          _vm._l(_vm.error.errors, function (messages, field) {
                            return _c("li", { key: field }, [
                              _vm._v(
                                _vm._s(_vm.label(field)) +
                                  ": " +
                                  _vm._s(
                                    _vm.readable([].concat(messages).join(" "))
                                  )
                              ),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.error.code === "stale_registry_edit"
                      ? _c(
                          "b-btn",
                          {
                            attrs: {
                              variant: "link",
                              size: "sm",
                              disabled: _vm.busy,
                            },
                            on: { click: _vm.reload },
                          },
                          [_vm._v("Discard draft and reload current record")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.error.existing_license_id
                      ? _c(
                          "b-btn",
                          {
                            attrs: { variant: "link", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.openLicense(
                                  _vm.error.existing_license_id
                                )
                              },
                            },
                          },
                          [_vm._v("Open existing license")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.error.existing_id
                      ? _c(
                          "b-btn",
                          {
                            attrs: { variant: "link", size: "sm" },
                            on: { click: _vm.openExistingEntity },
                          },
                          [_vm._v("Open existing " + _vm._s(_vm.error.type))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.action.kind === "resolve-conflict"
                      ? _c(
                          "b-btn",
                          {
                            attrs: {
                              variant: "link",
                              size: "sm",
                              disabled: _vm.busy,
                            },
                            on: { click: _vm.reload },
                          },
                          [_vm._v("Review current conflict")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.save.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "fieldset",
                  { attrs: { disabled: !_vm.canUpdate || _vm.busy } },
                  [
                    _vm.isLicenseCreation
                      ? [
                          _c("p", { staticClass: "small text-muted" }, [
                            _vm._v(
                              "State and license identity stay fixed. Imports replace initial details; later corrections stay."
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-sm-4",
                                  attrs: {
                                    label: "Issuing state",
                                    "label-for": _vm.id("state"),
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      id: _vm.id("state"),
                                      options: _vm.stateOptions,
                                      required: "",
                                    },
                                    on: { change: _vm.clearLookup },
                                    model: {
                                      value: _vm.form.issuing_state,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "issuing_state", $$v)
                                      },
                                      expression: "form.issuing_state",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-sm-8",
                                  attrs: {
                                    label: "License number",
                                    "label-for": _vm.id("number"),
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.id("number"),
                                      required: "",
                                    },
                                    on: { input: _vm.clearLookup },
                                    model: {
                                      value: _vm.form.license_number,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "license_number",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "form.license_number",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.representedStates.length
                            ? _c("p", { staticClass: "text-warning" }, [
                                _vm._v(
                                  "No states available. Retry registry settings or import the first state."
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              staticClass: "mb-3",
                              attrs: {
                                type: "button",
                                size: "sm",
                                variant: "outline-primary",
                                disabled:
                                  !_vm.form.issuing_state ||
                                  !_vm.form.license_number,
                              },
                              on: { click: _vm.checkIdentity },
                            },
                            [_vm._v("Check identity")]
                          ),
                          _vm._v(" "),
                          _vm.lookup
                            ? _c(
                                "div",
                                {
                                  staticClass: "border rounded p-2 mb-3",
                                  attrs: { role: "status" },
                                },
                                [
                                  _vm.lookup.license
                                    ? [
                                        _vm._v(
                                          "This identity already exists: " +
                                            _vm._s(
                                              _vm.identity(
                                                _vm.lookup.license.identity
                                              )
                                            ) +
                                            ".\n              "
                                        ),
                                        _c(
                                          "b-btn",
                                          {
                                            attrs: {
                                              type: "button",
                                              size: "sm",
                                              variant: "link",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openLicense(
                                                  _vm.lookup.license.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Open license")]
                                        ),
                                        _vm._v(" "),
                                        _vm.action.kind === "replace"
                                          ? _c(
                                              "p",
                                              { staticClass: "small mb-0" },
                                              [
                                                _vm._v(
                                                  "Save reuses this license and keeps its facts."
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    : _vm.lookup.outcome === "not_found"
                                    ? [
                                        _vm._v(
                                          "No match. Save creates a new license."
                                        ),
                                      ]
                                    : _vm.lookup.outcome ===
                                      "conflicting_identity"
                                    ? [
                                        _vm._v(
                                          "\n              This identity is disputed. Review the original license first.\n              "
                                        ),
                                        _vm._l(
                                          _vm.lookup.conflicts || [],
                                          function (conflict) {
                                            return _c(
                                              "div",
                                              { key: conflict.id },
                                              [
                                                _c(
                                                  "b-btn",
                                                  {
                                                    attrs: {
                                                      type: "button",
                                                      variant: "link",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openLicense(
                                                          conflict.original_license_id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.identity(
                                                          conflict.original_identity
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            (_vm.lookup.reasons || [])
                                              .map(_vm.label)
                                              .join(", ") ||
                                              _vm.label(_vm.lookup.outcome)
                                          )
                                        ),
                                      ],
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.reusingLicense
                            ? [
                                _c("RegistryClassificationFields", {
                                  attrs: {
                                    designations:
                                      _vm.metadata.designations || [],
                                    activities:
                                      _vm.metadata.manual_business_types || [],
                                    "server-errors": _vm.error
                                      ? _vm.error.errors
                                      : {},
                                    "show-validation": _vm.validated,
                                  },
                                  model: {
                                    value: _vm.form.classification,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "classification", $$v)
                                    },
                                    expression: "form.classification",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "col-sm-6",
                                        attrs: {
                                          label: "Legal name",
                                          "label-for": _vm.id("legal-name"),
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: { id: _vm.id("legal-name") },
                                          model: {
                                            value: _vm.form.legal_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "legal_name",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "form.legal_name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "col-sm-6",
                                        attrs: {
                                          label: "Common name",
                                          "label-for": _vm.id("common-name"),
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: { id: _vm.id("common-name") },
                                          model: {
                                            value: _vm.form.common_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "common_name",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "form.common_name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "details",
                                  { staticClass: "mb-3" },
                                  [
                                    _c("summary", [
                                      _vm._v("Additional details"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mt-2",
                                        attrs: {
                                          label: "Reported status",
                                          "label-for": _vm.id("status"),
                                        },
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            id: _vm.id("status"),
                                            options: _vm.statusOptions,
                                          },
                                          model: {
                                            value: _vm.form.status,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "status", $$v)
                                            },
                                            expression: "form.status",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Expiration date",
                                          "label-for": _vm.id("expiration"),
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: _vm.id("expiration"),
                                            type: "date",
                                          },
                                          model: {
                                            value: _vm.form.expiration_date,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "expiration_date",
                                                $$v
                                              )
                                            },
                                            expression: "form.expiration_date",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "small text-muted" },
                                      [
                                        _vm._v(
                                          "Unknown status remains Uncertain. Order placement also needs Active standing and a linked location with a complete address."
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.action.kind === "replace"
                            ? [
                                _c("p", { staticClass: "small" }, [
                                  _vm._v(
                                    "Customers, pricing and orders stay with the original license. Review those links separately."
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "mb-3",
                                    model: {
                                      value: _vm.form.inactivate_original,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "inactivate_original",
                                          $$v
                                        )
                                      },
                                      expression: "form.inactivate_original",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "Locally inactivate the original license"
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ]
                      : _vm.action.kind === "create-entity"
                      ? [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Record type",
                                "label-for": _vm.id("type"),
                              },
                            },
                            [
                              _c("b-form-select", {
                                key: _vm.controlVersion,
                                attrs: {
                                  id: _vm.id("type"),
                                  value: _vm.form.entity.type,
                                  options: _vm.entityTypes,
                                },
                                on: { change: _vm.changeType },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("RegistryActionEntityFields", {
                            model: {
                              value: _vm.form.entity,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "entity", $$v)
                              },
                              expression: "form.entity",
                            },
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "small text-muted" }, [
                            _vm._v(
                              "Add manual links separately. Matching supplier links resolve automatically."
                            ),
                          ]),
                        ]
                      : _vm.action.kind === "inactivate"
                      ? [
                          _c("p", [
                            _vm._v(
                              "Make " +
                                _vm._s(
                                  _vm.identity(
                                    (_vm.action.license || {}).identity
                                  )
                                ) +
                                " unavailable for new active-only use. Existing customer, pricing and order references stay."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "small text-muted" }, [
                            _vm._v(
                              "This changes availability in Greenlists, not regulatory status."
                            ),
                          ]),
                        ]
                      : _vm.action.kind === "reactivate"
                      ? [
                          _c("p", [
                            _vm._v(
                              "Reactivate " +
                                _vm._s(
                                  _vm.identity(
                                    (_vm.action.license || {}).identity
                                  )
                                ) +
                                " in Greenlists. Current evidence still determines standing."
                            ),
                          ]),
                        ]
                      : _vm.action.kind === "associate-location"
                      ? [
                          _c("p", [
                            _vm._v(
                              "Choose the supplier location for " +
                                _vm._s(_vm.entityName(_vm.action.entity)) +
                                ". Check its name and address. Supplier evidence is checked on Save."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("RegistryActionTargetPicker", {
                            attrs: {
                              types: _vm.locationType,
                              "supplier-identity": "",
                            },
                            model: {
                              value: _vm.form.target,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "target", $$v)
                              },
                              expression: "form.target",
                            },
                          }),
                          _vm._v(" "),
                          _c("details", { staticClass: "my-3" }, [
                            _c("summary", [_vm._v("Links affected")]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "small" },
                              [
                                _vm._l(
                                  _vm.associationLicenses.items || [],
                                  function (item) {
                                    return _c(
                                      "li",
                                      { key: `license-${item.license_id}` },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.identity(item.identity)) +
                                            " · " +
                                            _vm._s(_vm.label(item.role))
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.associationContacts.items || [],
                                  function (item) {
                                    return _c(
                                      "li",
                                      { key: `contact-${item.entity_id}` },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.readable(
                                              item.name || "Unnamed contact"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "small" }, [
                              _vm._v(
                                _vm._s(_vm.associationLicenses.total || 0) +
                                  " license links and " +
                                  _vm._s(_vm.associationContacts.total || 0) +
                                  " contact links move, including any beyond this preview."
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "small" }, [
                            _vm._v(
                              "The manual record keeps its details and history, but cannot take new links. Customers and placed orders stay unchanged. Draft orders must reselect the supplier location."
                            ),
                          ]),
                        ]
                      : _vm.action.kind === "resolve-conflict"
                      ? [
                          _c("p", [
                            _vm._v("Current identity: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.identity(_vm.conflict.original_identity)
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Incoming identity: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.identity(_vm.conflict.asserted_identity)
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "small" }, [
                            _vm._v(
                              _vm._s(
                                _vm.readable(
                                  (_vm.conflict.disputed_version || {})
                                    .legal_name || ""
                                )
                              ) +
                                " · " +
                                _vm._s(
                                  _vm.readable(
                                    (_vm.conflict.disputed_version || {})
                                      .status_raw || "No reported status"
                                  )
                                ) +
                                " · Expires " +
                                _vm._s(
                                  _vm.readable(
                                    (_vm.conflict.disputed_version || {})
                                      .expiration_raw || "Not supplied"
                                  )
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("details", { staticClass: "mb-3" }, [
                            _c("summary", [_vm._v("Evidence and history")]),
                            _c("pre", { staticClass: "registry-evidence" }, [
                              _vm._v(_vm._s(_vm.evidence(_vm.conflict))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { attrs: { label: "Resolution" } },
                            [
                              _c(
                                "b-form-radio-group",
                                {
                                  attrs: { stacked: "" },
                                  model: {
                                    value: _vm.form.resolution,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "resolution", $$v)
                                    },
                                    expression: "form.resolution",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: "reject" } },
                                    [
                                      _vm._v(
                                        "Reject the Disputed License Claim and keep the accepted association"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: "accept" } },
                                    [
                                      _vm._v(
                                        "Accept incoming evidence for " +
                                          _vm._s(
                                            _vm.identity(
                                              _vm.conflict.asserted_identity
                                            )
                                          ) +
                                          ". " +
                                          _vm._s(
                                            _vm.conflict
                                              .accept_will_create_license ===
                                              true
                                              ? "Create the new identity."
                                              : _vm.conflict
                                                  .accept_will_create_license ===
                                                false
                                              ? "Reuse the existing identity."
                                              : "The server reuses the matching identity or creates it."
                                          )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "small" }, [
                            _vm._v(
                              "Accept moves the current source evidence. License identities, commercial links, snapshots and admin inactivation stay unchanged. Earlier evidence stays in history."
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Reason",
                          "label-for": _vm.id("reason"),
                        },
                      },
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: _vm.id("reason"),
                            "data-test": "action-reason",
                            rows: "2",
                            required: ![
                              "create-license",
                              "create-entity",
                            ].includes(_vm.action.kind),
                          },
                          model: {
                            value: _vm.form.reason,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "reason",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.reason",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.consequential
                      ? _c(
                          "b-form-checkbox",
                          {
                            staticClass: "mb-3",
                            model: {
                              value: _vm.form.confirmed,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "confirmed", $$v)
                              },
                              expression: "form.confirmed",
                            },
                          },
                          [_vm._v(_vm._s(_vm.confirmationLabel))]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end mt-3" },
                  [
                    _c(
                      "b-btn",
                      {
                        staticClass: "mr-2",
                        attrs: {
                          type: "button",
                          variant: "outline-secondary",
                          disabled: _vm.busy,
                        },
                        on: { click: _vm.cancel },
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        attrs: {
                          type: "submit",
                          variant: "primary",
                          disabled:
                            !_vm.canUpdate ||
                            _vm.busy ||
                            !_vm.dirty ||
                            (_vm.consequential && !_vm.form.confirmed),
                        },
                      },
                      [_vm._v(_vm._s(_vm.busy ? "Saving..." : "Save"))]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }